import type { ProjectDocument } from '../types/project';
import { apiFetch } from './apiClient';

export type ValidationSeverity = 'error' | 'warning';
export type ValidationIssue = {
  code: string;
  path: string;
  message: string;
  severity: ValidationSeverity;
};
export type ValidationResult = {
  valid: boolean;
  errors: ValidationIssue[];
  warnings: ValidationIssue[];
};

export async function validateProject(doc: unknown): Promise<ValidationResult> {
  const response = await apiFetch('/api/projects/validate', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(doc),
  });
  if (response.status === 200 || response.status === 422) {
    const body = await response.json() as Partial<ValidationResult>;
    return {
      valid: body.valid === true,
      errors: Array.isArray(body.errors) ? body.errors : [],
      warnings: Array.isArray(body.warnings) ? body.warnings : [],
    };
  }
  const body = await response.json().catch(() => ({})) as { message?: string; error?: string };
  throw new Error(body.message ?? body.error ?? `Validation service returned HTTP ${response.status}.`);
}

export function asProjectDocument(value: unknown): ProjectDocument {
  return value as ProjectDocument;
}
